import React from "react";

function MiniRotaryTabletPress() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Mini Rotary Tablet Press</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Mini Rotary Tablet Press</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE */}
                  <div className="blog-images wow fadeInUp" data-wow-delay=".1s"style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className="col-sm-6">
                    <img
                      src="assets/images/SD_PHRMA_ALL_MIX _JPGS/13.png"
                      alt="Mini Rotary Tablet Press"
                    />
                    </div>
                  </div>

                  <h2 className="title title-anim">
                    Mini Rotary Tablet Press
                  </h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Mini Rotary Tablet Press is compact, efficient, and designed
                      for small-scale production, R&D departments, pilot batches,
                      and formulation development. Despite its small footprint, it
                      delivers reliable compression performance with smooth
                      operation.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Built with stainless steel contact parts, precise adjustment
                      controls, and user-friendly operation, it provides consistent
                      tablet hardness, thickness, and weight uniformity with minimal
                      maintenance.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/13.png" alt="Image" />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/14.png" alt="Image" />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MP-8</td>
                          <td>DPM-MP-10</td>
                          <td>DPM-MP-12</td>
                        </tr>

                        <tr>
                          <td>Number of Stations</td>
                          <td>8</td>
                          <td>10</td>
                          <td>12</td>
                        </tr>

                        <tr>
                          <td>Output (Tablets / Hour)</td>
                          <td>7,680</td>
                          <td>9,600</td>
                          <td>11,520</td>
                        </tr>

                        <tr>
                          <td>Max Tablet Diameter</td>
                          <td>16 mm</td>
                          <td>16 mm</td>
                          <td>16 mm</td>
                        </tr>

                        <tr>
                          <td>Max Depth of Fill</td>
                          <td>17 mm</td>
                          <td>17 mm</td>
                          <td>17 mm</td>
                        </tr>

                        <tr>
                          <td>Main Compression Pressure</td>
                          <td>6.5 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6.5 Tons</td>
                        </tr>

                        <tr>
                          <td>Turret Speed</td>
                          <td>16 RPM</td>
                          <td>16 RPM</td>
                          <td>16 RPM</td>
                        </tr>

                        <tr>
                          <td>Main Motor</td>
                          <td>1 HP</td>
                          <td>1 HP</td>
                          <td>1 HP</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>650 × 550 × 1200 mm</td>
                          <td>650 × 550 × 1200 mm</td>
                          <td>650 × 550 × 1200 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>350 kg</td>
                          <td>350 kg</td>
                          <td>350 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>
                      <li>
                        <a href="/single-rotary-tablet-press">
                          Single Rotary Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/single-rotary-tablet-press-non-gmp">
                          Single Rotary Tablet Press (Non-GMP)
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/double-side-rotary-tableting-machine">
                          Double Side Rotary Tableting Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default MiniRotaryTabletPress;
